import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";
import Tab from "@mui/material/Tab";

import { InfoIcon, WifiOffIcon } from "@dotnet/telematics-design-system";

import CloneProps from "components/CloneProps";
import SegmentedToggle, {
    TAB_SIZES
} from "components/DesignComponents/SegmentedToggle";
import {
    TOOLTIP_PLACEMENT,
    TooltipGeneral
} from "components/DesignComponents/Tooltips";
import { useMediaQueries } from "shared";

import { TabSectionProps } from "../types";

const TabSection = ({
    tabValue,
    isEnabled,
    handleTabChange
}: TabSectionProps) => {
    const { t } = useTranslation();
    const { toMd } = useMediaQueries();

    return (
        <div>
            <SegmentedToggle
                value={tabValue}
                size={TAB_SIZES.Small}
                tabWidth="377px"
                fullWidth={toMd}
                onChange={handleTabChange}
            >
                <Tab label="License details" icon={<InfoIcon />} />

                <CloneProps>
                    {(tabProps: any) => (
                        <TooltipGeneral
                            placement={TOOLTIP_PLACEMENT.Top}
                            title={
                                !isEnabled
                                    ? t("Table##offline licenses tab disabled")
                                    : ""
                            }
                        >
                            <div>
                                <Tab
                                    {...tabProps}
                                    label={t("General##offline licenses")}
                                    icon={<WifiOffIcon />}
                                    disabled={!isEnabled}
                                    css={css({
                                        width: "100%"
                                    })}
                                />
                            </div>
                        </TooltipGeneral>
                    )}
                </CloneProps>
            </SegmentedToggle>
        </div>
    );
};

export default TabSection;
